import React from 'react';
import { Card, Space, Tag, Typography } from 'antd';
import { theme } from '../utils/theme';

const { Title, Text } = Typography;

const StatCard = ({ icon, title, value, subtitle, trend, trendDown, color }) => (
  <Card style={{ borderRadius: '8px' }}>
    <Space style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
      <div style={{
        backgroundColor: theme[`light${color.charAt(1).toUpperCase() + color.slice(2)}`],
        color: theme[color],
        width: '40px',
        height: '40px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {icon}
      </div>
      {trend && (
        <Tag color={trendDown ? theme.red : theme.green}>
          {trend}
        </Tag>
      )}
    </Space>
    <Text type="secondary">{title}</Text>
    <Title level={3} style={{ margin: '8px 0 0' }}>{value}</Title>
    {subtitle && <Text type="secondary">{subtitle}</Text>}
  </Card>
);

export default StatCard;